import { CourseData } from "@/interface/viewClass";
import { API_BASE_URL } from "@/utils/api";
import { Dispatch, SetStateAction } from "react";

export const dataCourseDetail = async (
  userId: number,
  token: string,
  id: string,
  setCourse: Dispatch<SetStateAction<CourseData | null>>,
) => {
  const response = await fetch(
    `${API_BASE_URL}/dashboard/${userId}/my-classes`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );

  const rawData = await response.json();

  if (rawData && rawData.data) {
    const foundCourse = rawData.data.find(
      (c: CourseData) => String(c.id) === id,
    );
    if (foundCourse) {
      setCourse(foundCourse);
    }
  }

  return response;
};
